import $ from "jquery"
import Swiper from "swiper"

import { VIMEO_PLAYER_EVENTS } from "../vimeo-video/vimeo-video"

class HeaderImageWithVideo {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("HeaderImageWithVideo::initialize()")

		this._$component = $(".bb-header-image-with-video")
		this._$player = this._$component.find(".bb-vimeo-video:visible")
		this._$playerHidden = this._$component.find(".bb-vimeo-video:hidden")
		this._$controlsContainer = this._$component.find(".bb-header-image-with-video__video-controls")

		if (this._$component.find(".swiper").length) {
			this._swiper = new Swiper(this._$component.find(".swiper").get(0), {
				slidesPerView: 1,
				speed: 700,
				autoplay: false,
				loop: false,
				on: {
					slideChange: (swiper) => {
						window.clearTimeout(this._slideTimeout)

						$(".bb-header-image-with-video__pagination span").text(swiper.realIndex + 1)

						if (this._$player.length && this._$controlsContainer.hasClass("is-playing")) {
							this._stopVideo()
						}
					},
					slideChangeTransitionEnd: (swiper) => {
						if (this._$player.length) {
							if ($(swiper.slides[swiper.activeIndex]).children().first().hasClass("bb-vimeo-video")) {
								this._playVideo()
							} else {
								this._resetVideo()
							}
						}
					},
				},
			})
		}

		if (this._$player.length) {
			const player = this._$player.get(0)

			player.addEventListener(VIMEO_PLAYER_EVENTS.ENDED, () => {
				this._$controlsContainer.removeClass("is-playing")
				if (this._swiper) {
					this._swiper.activeIndex === 0 ? this._swiper.slideNext() : this._swiper.slidePrev()
				} else {
					this._resetVideo()
				}
			})

			$(document.body).on("click", ".bb-header-image-with-video__video-controls .bb-icon", () => {
				if (this._$controlsContainer.hasClass("is-playing")) {
					this._stopVideo()
				} else {
					this._playVideo()
				}
			})

			// if fist slide is image, slide to video after 5 seconds
			if (this._swiper && $(this._swiper.slides[0]).find(".bb-image").length) {
				this._slideTimeout = window.setTimeout(() => {
					this._swiper.slideNext()
				}, 5000)
			}

			// stop hidden video
			// this._$playerHidden.get(0).dispatchEvent(new CustomEvent(VIMEO_PLAYER_EVENTS.RESET))

			if ("MutationObserver" in window) {
				const observer = new MutationObserver((entries) => {
					let noCookies = false
					entries.forEach((entry) => {
						Object.values(entry.addedNodes).forEach((item) => {
							if (item.nodeName === "IFRAME") {
								this._$component.removeClass("no-cookie-accepted")
								noCookies = false
								window.setTimeout(() => {
									if (!noCookies) {
										this._playVideo()
									}
								}, 1000)
							} else if ($(item).hasClass("uc-embedding-container")) {
								this._$component.addClass("no-cookie-accepted")
								this._stopVideo()
								noCookies = true
							}
						})
					})
				})

				const vimeoVideo = document.querySelector(".bb-vimeo-video")
				observer.observe(vimeoVideo, {
					subtree: true,
					childList: true,
				})
			}

			$(window).on("resize", this._onResize.bind(this))
		}
	}

	_playVideo() {
		this._$controlsContainer.addClass("is-playing")
		this._$player.get(0).dispatchEvent(new CustomEvent(VIMEO_PLAYER_EVENTS.PLAY))
	}

	_stopVideo() {
		this._$controlsContainer.removeClass("is-playing")
		this._$player.get(0).dispatchEvent(new CustomEvent(VIMEO_PLAYER_EVENTS.STOP))
	}

	_resetVideo() {
		this._$controlsContainer.removeClass("is-playing")
		this._$player.get(0).dispatchEvent(new CustomEvent(VIMEO_PLAYER_EVENTS.RESET))
		this._$playerHidden.get(0).dispatchEvent(new CustomEvent(VIMEO_PLAYER_EVENTS.RESET))
	}

	_onResize() {
		// changed between  mobile and desktop view
		if (!this._$player.is(":visible")) {
			this._stopVideo()
			this._$player = this._$component.find(".bb-vimeo-video:visible")
			this._$playerHidden = this._$component.find(".bb-vimeo-video:hidden")
		}
	}
}

export default HeaderImageWithVideo
